import GenerateSQL from './GenerateSQL'

export default GenerateSQL
